var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAlertNostart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_alert_nostart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 2H8.25467C8.37844 2.00006 8.49975 2.03353 8.60502 2.09666C8.71028 2.15978 8.79534 2.25007 8.85067 2.35741L9.33333 3.29263H13.3333C13.5101 3.29263 13.6797 3.36073 13.8047 3.48193C13.9298 3.60314 14 3.76753 14 3.93895V11.0484C14 11.2198 13.9298 11.3842 13.8047 11.5054C13.6797 11.6266 13.5101 11.6947 13.3333 11.6947H9.07867C8.95489 11.6947 8.83358 11.6612 8.72832 11.5981C8.62305 11.535 8.53799 11.4447 8.48267 11.3373L8 10.4021H3.33333V14.28H2V2Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Vector_2",
    cx: 11.8492,
    cy: 11.8502,
    r: 4.15,
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5996 13.3636H11.0996V14.8182H12.5996V13.3636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5996 9H11.0996V12.6364H12.5996V9Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertNostart);
export default __webpack_public_path__ + "static/media/ic_alert_nostart.766f2bdef265d7bd166b26e339dac458.svg";
export { ForwardRef as ReactComponent };